import ComingSoon from "@/components/ComingSoon";

export default function VulnerabilitiesPage() {
  return <ComingSoon featureName="Vulnerability Scanning" description="Monitor and manage CVEs across OS updates and applications. This feature requires backend Vulnerability Scanning APIs." />;
}
